import { currentLangString, LOCALE_COOKIE } from '../../i18nInit'
import { Preferences } from '@capacitor/preferences'

function removeCookies() {
  const res = document.cookie
  const multiple = res.split(';')

  for (let i = 0; i < multiple.length; i += 1) {
    const key = multiple[i].split('=')
    document.cookie = key[0] + ' =; expires = Thu, 01 Jan 1970 00:00:00 UTC'
  }
}

export async function removeCookiesAndStorage() {
  removeCookies()
  localStorage.clear()
  await Preferences.clear()
  await Preferences.set({ key: LOCALE_COOKIE, value: currentLangString })
}
